'use client';
import React, { useContext } from 'react';
import { DateInputMaskFormat, DateTimeFormat, ExampleGenerator, AddressFormat, PhoneNumberFormat, DisplayNames, CurrencyFormat, MessageFormat } from '@paypalcorp/worldready';
import { Context } from '@paypalcorp/worldready-react';
import { IntlProvider } from '@paypalcorp/pp-react-intl';

var WorldReadyProvider = function (_ref) {
  var worldReady = _ref.worldReady,
    children = _ref.children;
  var worldReadObjFromContext = useContext(Context);
  var worldReadyObj = worldReady || worldReadObjFromContext;
  var intlProviderProps = {
    locale: worldReadyObj.locale,
    messageFormatter: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new MessageFormat(worldReadyObj, options);
    },
    currencyFormatter: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new CurrencyFormat(worldReadyObj, options);
    },
    getDisplayNamesObject: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new DisplayNames(worldReadyObj, options);
    },
    phoneFormatter: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new PhoneNumberFormat(options);
    },
    addressFormatter: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new AddressFormat(worldReadyObj, options);
    },
    exampleGenerator: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new ExampleGenerator(options);
    },
    dateTimeFormatter: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new DateTimeFormat(worldReadyObj, options);
    },
    dateInputMaskFormat: function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new DateInputMaskFormat(worldReadyObj, options);
    },
    worldReadyObj: worldReadyObj
  };
  return /*#__PURE__*/React.createElement(IntlProvider, intlProviderProps, children);
};

export { WorldReadyProvider };
